module.exports = __webpack_public_path__ + "img/34-audioVEQ.7472f958.jpg";